import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { YardiDatabase } from "../typeDefs/yardidata";

export interface YardiDataState {
	yardiDbs: YardiDatabase[];
	needsCreds: boolean;
	credsLoading: boolean;
	selectedDb?: YardiDatabase;
	timeZones: string[];
	serverName: string;
	serverLoading: boolean;
	isLockedDown: boolean;
}

const initialState: YardiDataState = {
	yardiDbs: [],
	needsCreds: true,
	credsLoading: true,
	selectedDb: undefined,
	timeZones: [],
	serverName: "",
	serverLoading: false,
	isLockedDown: true,
};

export const yardidata = createSlice({
	name: "userprofiles",
	initialState,
	reducers: {
		setYardiDbs: (state, action: PayloadAction<YardiDatabase[]>) => {
			state.yardiDbs = action.payload;
		},
		setNeedsCreds: (state, action: PayloadAction<boolean>) => {
			state.needsCreds = action.payload;
		},
		setCredsLoading: (state, action: PayloadAction<boolean>) => {
			state.credsLoading = action.payload;
		},
		setSelectedDb: (
			state,
			action: PayloadAction<YardiDatabase | undefined>
		) => {
			state.selectedDb = action.payload;
		},
		setTimeZones: (state, action: PayloadAction<string[]>) => {
			state.timeZones = action.payload;
		},
		setServerName: (state, action: PayloadAction<string>) => {
			state.serverName = action.payload;
		},
		setServerLoading: (state, action: PayloadAction<boolean>) => {
			state.serverLoading = action.payload;
		},
		setLockedDown: (state, action: PayloadAction<boolean>) => {
			state.isLockedDown = action.payload;
		},
	},
});

export const {
	setYardiDbs,
	setNeedsCreds,
	setCredsLoading,
	setSelectedDb,
	setTimeZones,
	setServerName,
	setServerLoading,
	setLockedDown,
} = yardidata.actions;

export default yardidata.reducer;
